import { Suspense, FC } from "react";

import dynamic from "next/dynamic";
const DetailHeader = dynamic(() => import("./DetailHeader"), {
  suspense: true,
});
const Description = dynamic(() => import("./Description"), {
  suspense: true,
});

interface IProps {
  data: any;
}

const Index: FC<IProps> = ({ data }) => {
  return (
    <main>
      <Suspense
        fallback={
          <>
            <p>Loading....</p>
          </>
        }
      >
        <DetailHeader
          title={data.projectTitle}
          city={data.city}
          occupancy={data.occupancy}
          logo={data.logo}
        />
      </Suspense>
      <Suspense
        fallback={
          <>
            <p>Loading....</p>
          </>
        }
      >
        <Description data={data} />
      </Suspense>
    </main>
  );
};

export default Index;
